import React, { useContext, useReducer, useEffect } from "react";

import { reducer } from "../reducer/todos-reducer";

const todosContext = React.createContext();

let id = 1;

const MOCK_TODOS = [
  { id: id++, status: true, todo: "Complete online javascript course" },
  { id: id++, status: false, todo: "Jog around the park 3x" },
  { id: id++, status: false, todo: "10 minutes medidation" },
];

const checkTodosOnLocaleStorage = () => {
  const localeTodos = localStorage.getItem("todos");

  if (!localeTodos) {
    return [];
  }
  return JSON.parse(localeTodos);
};

const initialState = {
  _todos: checkTodosOnLocaleStorage(),
  todos: [],
  filters: "all",
  totalTodos: 0,
  loading: false,
};

// const status = [0, 1];

const TodosProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const calculateTotal = () => {
    dispatch({ type: "CALCULATE_TOTAL_LEFT" });
  };

  const createNewTodo = (newTodo) => {
    dispatch({ type: "NEW_TODO", payload: newTodo });
  };

  const changeTodoStatus = async (id, status) => {
    await dispatch({ type: "CHANGE_TODO_STATUS", payload: { id, status } });
    setTodosOnLocaleStorage();
    calculateTotal();
  };

  const filterTodos = (value) => {
    dispatch({ type: "FILTER_TODOS", payload: { value } });
  };

  const clearCompleted = () => {
    dispatch({ type: "CLEAR_COMPLETED" });
  };

  const clearTodo = (id) => {
    dispatch({ type: "CLEAR_TODO", payload: id });
  };

  const setTodosOnLocaleStorage = () => {
    localStorage.setItem("todos", JSON.stringify(state._todos));
  };

  useEffect(() => {
    filterTodos("all");
  }, []);

  useEffect(() => {
    calculateTotal();
    filterTodos(state.filters);
    setTodosOnLocaleStorage();
  }, [state._todos]);

  return (
    <todosContext.Provider
      value={{
        ...state,
        createNewTodo,
        filterTodos,
        changeTodoStatus,
        clearCompleted,
        clearTodo,
      }}
    >
      {children}
    </todosContext.Provider>
  );
};

export const useTodosContext = () => {
  return useContext(todosContext);
};
export { TodosProvider };
